import { useContext } from 'react'
import { Link } from 'react-router-dom'
import { ModalTotalContext } from '../../../../context/ModalContext'
import { ContentItem } from '../style'
import { SubMenuItem } from './style'
const SubMenu = ({ value, pathname }) => {
  const { setOpenModal } = useContext(ModalTotalContext)
  return (
    <Link to={value.link} onClick={() => setOpenModal(null)}>
      <SubMenuItem>
        <ContentItem className="hover" sub active={value.link === pathname}>
          <div>
            {value.icon}
            <span className="title">{value.title}</span>
          </div>
        </ContentItem>
      </SubMenuItem>
    </Link>
  )
}
export default SubMenu
